import type { ComputedRef } from 'vue';

import { SpacingDensities } from '../../../types/misc';

export enum Layout {
  Scroll = 'scroll',
  Stack = 'stack',
}

export type Layouts = `${Layout}`;

export enum TableRadius {
  None = 'none',
  Rounded = 'rounded',
  RoundedBottom = 'rounded-bottom',
}

export type TableRadiuses = `${TableRadius}`;

/**
 * Properties and utilities provided to children of a Table instance
 */
export interface TableInjection {
  /**
   * Controls the Table's padding; the default value is "comfortable". On small screens, the density will always be "compact".
   */
  density: ComputedRef<SpacingDensities>;

  /**
   * Styles the last column for "row actions"
   */
  hasActions: ComputedRef<boolean>;

  /**
   * If true, hides the default expansion toggle column
   */
  hasCustomExpandToggle: ComputedRef<boolean>;

  /**
   * When true, the table is schema-driven (e.g. DataTable); selection column is rendered from the schema, not by TableRow/TableHeaderRow.
   */
  isSchemaDriven?: ComputedRef<boolean>;

  /**
   * Adds a toggle column for row expansion. This is primarily needed for ensuring the corresponding empty TableHeaderRow is included.
   */
  isExpandable: ComputedRef<boolean>;

  /**
   * Adds a checkbox column for selecting rows; intended for use with the `useSelection` composable.
   */
  isSelectable: ComputedRef<boolean>;

  /**
   * Sets the table layout; the default value is "scroll".
   */
  layout: ComputedRef<Layouts>;

  /**
   * Sets the table loading state.
   */
  isLoading: ComputedRef<boolean>;
}
